<ng-container *ngIf="finalMarkCriteria">
    <h2 class="_sansSerif _primary"[i18nKey]="'evaluations.final.mark.criteria.title'"></h2>
    <kiwi-spacer [size]="4"></kiwi-spacer>
    <h6 [i18nKey]="'evaluations.final.mark.criteria.marks.weights'"></h6>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <form #finalMarkCriteriaForm="ngForm" (ngSubmit)="save()">
        <div class="grid-x grid-margin-x grid-margin-y">
            <label class="cell small-8">
                <span [i18nKey]="'evaluations.final.mark.criteria.treasury.mark.weight'"></span>
                <input [(ngModel)]="finalMarkCriteria.marksWeights.treasuryMarkWeight"
                       type="number"
                       name="treasuryMarkWeight"
                       (change)="onValueUpdate()"
                       required/>
            </label>
            <label class="cell small-8">
                <span [i18nKey]="'evaluations.final.mark.criteria.profitability.mark.weight'"></span>
                <input [(ngModel)]="finalMarkCriteria.marksWeights.profitabilityMarkWeight"
                       type="number"
                       name="profitabilityMarkWeight"
                       (change)="onValueUpdate()"
                       required/>
            </label>
            <label class="cell small-8">
                <span [i18nKey]="'evaluations.final.mark.criteria.customer.satisfaction.mark.weight'"></span>
                <input [(ngModel)]="finalMarkCriteria.marksWeights.customerSatisfactionMarkWeight"
                       type="number"
                       name="customerSatisfactionMarkWeight"
                       (change)="onValueUpdate()"
                       required/>
            </label>
        </div>

        <kiwi-spacer [size]="32"></kiwi-spacer>

        <table class="_tableColor">
            <tbody>
            <tr>
                <td [i18nKey]="'evaluations.final.mark.criteria.mark.max'"></td>
                <td>
                    <input [(ngModel)]="finalMarkCriteria.maxMark"
                           type="number"
                           name="maxMark"
                           (change)="onValueUpdate()"
                           required/>
                </td>
            </tr>
            </tbody>
        </table>

        <kiwi-spacer [size]="32"></kiwi-spacer>

        <div class="grid-x align-center">
            <button class="cell shrink button" type="submit" [disabled]="finalMarkCriteriaForm.invalid"[i18nKey]="'common.action.save'"></button>
        </div>
    </form>
</ng-container>
